import React, { useContext, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { format, parseISO } from 'date-fns';
import PropTypes from 'prop-types';
import CdnImageBackground from '../../common/CdnImageBackground';
import { H4, H6 } from '../../text';
import { cleanupInternalUrl } from '../../../common/Utils';
import AppContext from '../../../contexts/App';
import LayoutContext from '../../../contexts/Layout';
import { fetchPage } from '../../../common/Api';
import { MODERN_LAYOUT_COLLAPSE_WIDTH } from '../../../contexts/Layout';

export const EventGridItem = ({
    eventGridLastItem,
    enableImageOverlay,
    eventTitle,
    eventTitleColor,
    featuredImage,
    index,
    ministry = [],
    rootPath,
    startDateAndTime,
    width
}) => {
    const { layout } = useContext(LayoutContext);
    const { dispatch } = useContext(AppContext);
    const [imageDimensions, setImageDimensions] = useState(); // todo: dimensions need to apply to row not individual item, otherwise odd spacing separations @jacksonkr

    const itemWidth = width <= MODERN_LAYOUT_COLLAPSE_WIDTH || eventGridLastItem ? width : Math.floor(width * 0.5);

    return (
        <CdnImageBackground
            enableOverlay={enableImageOverlay}
            gradientLocations={[0.25, 0.99]}
            imageDimensions={imageDimensions}
            onPress={async () => await fetchPage(dispatch, cleanupInternalUrl(rootPath))}
            setImageDimensions={setImageDimensions}
            style={{ marginBottom: index % 2 !== 0 ? 0 : 2.5, marginRight: index % 2 === 0 ? 2.5 : 0 }}
            uri={featuredImage?.cdnImagePath}
            usePointer={true}
            width={itemWidth}
        >
            <View
                style={StyleSheet.flatten(Styles.contentContainer, { height: Math.floor(imageDimensions?.height - 10), marginLeft: layout.styleGuide.spacer2 })}
                dataSet={{ spacerLeft: `StyleGuide.Spacer2(${layout.styleGuide.spacer2})` }}
            >
                <View style={Styles.dateBubble}>
                    <H4 style={{ fontWeight: 'bold' }} text={format(typeof startDateAndTime === 'string' ? parseISO(startDateAndTime) : new Date(startDateAndTime), 'd')} />
                    <H4
                        style={{ color: '#7f868b', fontSize: layout.device.os.equals('web') ? '16pt' : 16 }}
                        text={format(typeof startDateAndTime === 'string' ? parseISO(startDateAndTime) : new Date(startDateAndTime), 'MMM').toLocaleUpperCase()}
                    />
                </View>
                <View style={Styles.detailsContainer}>
                    <H4 style={{ color: eventTitleColor || 'white', paddingBottom: 2, maxWidth: itemWidth * 0.75 }} text={eventTitle} />
                    <H6
                        style={StyleSheet.flatten(Styles.description, { color: eventTitleColor || '#fff' })}
                        text={format(typeof startDateAndTime === 'string' ? parseISO(startDateAndTime) : new Date(startDateAndTime), 'EEEE MMMM d yyyy, h:mm a')}
                    />
                    {ministry.length > 0 && <H6 style={StyleSheet.flatten(Styles.description, { color: eventTitleColor || '#fff' })} text={ministry[0]} />}
                </View>
            </View>
        </CdnImageBackground>
    );
};

const Styles = StyleSheet.create({
    contentContainer: {
        backgroundColor: 'transparent',
        height: '100%' //400
    },
    dateBubble: {
        alignItems: 'center',
        backgroundColor: 'white',
        borderRadius: 12,
        height: 70,
        justifyContent: 'center',
        padding: 10,
        position: 'absolute',
        top: 10,
        maxWwidth: 80
    },
    description: {
        color: 'white',
        fontFamily: 'GothamBook'
    },
    detailsContainer: {
        bottom: 5,
        color: 'white',
        position: 'absolute'
    }
});

EventGridItem.propTypes = {
    enableImageOverlay: PropTypes.bool,
    eventTitle: PropTypes.string,
    eventTitleColor: PropTypes.string,
    featuredImage: PropTypes.shape({
        cdnImagePath: PropTypes.string
    }),
    index: PropTypes.number,
    ministry: PropTypes.array,
    startDateAndTime: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};
